import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SignupRoutingModule } from './signup-routing.module';
import { SignupComponent } from './signup.component';
import { NgZorroAntdModule } from '../../../modules/nz-zorro-antd.module';
import { NgZorroIconModule } from '../../../modules/nz-icon-antd.module';
import { I18nService } from '../../../services/i18n.service';
import { HeaderModule } from '../../../shared/header/header.module';
import { FooterModule } from '../../../shared/footer/footer.module';
import { UtilityService } from '../../../services/utility.service';
import { ValidationErrorsModule } from '../../../shared/validation-errors/validation-errors.module';
import {InputFieldModule} from "../../../shared/input-field/input-field.module";
import { TranslateModule } from '@ngx-translate/core';
import { PasswordFieldModule } from "../../../shared/password-field/password-field.module";

@NgModule({
	declarations: [
		SignupComponent
	],
	imports: [
		CommonModule,
		SignupRoutingModule,
		ReactiveFormsModule,
		FormsModule,
		NgZorroAntdModule,
		NgZorroIconModule,
		HeaderModule,
		FooterModule,
		ValidationErrorsModule,
		InputFieldModule,
		TranslateModule,
		PasswordFieldModule
	],
	exports: [
		SignupComponent
	],
	providers: [
		I18nService,
		UtilityService
	]
})

export class SignupModule { }
